// auditHelper.js
import axios from 'axios';

import { BASE_URL } from '../../config/axios';


export const saveAudit = async ({ tenderId, updatedBy, tableName, oldData, newData, action, tab_id }) => {
    const payload = {
        tender: tenderId,
        updated_by: updatedBy,
        update_table: tableName,
        previous_value: oldData || {},
        new_value: newData,
        action: action,
        tab_id: tab_id || null,
    };

    try {
        const response = await axios.post(`${BASE_URL}/siteproject/auditlog/`, JSON.parse(JSON.stringify(payload)), {
            headers: {
                "Content-Type": "application/json" // ✅ force reset
            }
        });
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: error.response?.data || error.message };
    }
};